// extracted by mini-css-extract-plugin
export default {"loader":"loader__FD4Q3","spin":"spin__3VHBD"};